// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from 'mapbox-gl';

// mapboxgl.accessToken = process.env.REACT_APP_MAPBOXGL_ACCESSTOKEN;
mapboxgl.accessToken =
  'pk.eyJ1IjoidGhlc29pbGNvbXBhbnkiLCJhIjoiY2wxYzhka3Z2MDUyZDNqcDRtMDJxazNtMSJ9.JolTtrDqRlYrxYOLqe_TCg';

export default mapboxgl;
